import React from "react";
import Modal from "./Modal";
import { toast } from "sonner";
import { Download, Smartphone } from "lucide-react";
import { buildVCard, downloadVCard } from "../lib/vcard";

export default function QRDialog({ open, onClose, card }) {
  if (!card) return null;
  const qrData = encodeURIComponent(buildVCard(card));
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=280x280&margin=10&data=${qrData}`;

  return (
    <Modal open={open} onClose={onClose} maxWidth="max-w-sm" testId="qr-dialog">
      <div className="p-6 text-center">
        <p className="overline text-blue-500 mb-1">Scan to save</p>
        <h2 className="font-heading text-2xl font-bold tracking-tight mb-1">
          {card.name || card.company}
        </h2>
        <p className="text-sm text-slate-400 mb-6 flex items-center justify-center gap-1.5">
          <Smartphone className="w-4 h-4" /> Point a phone camera to add instantly
        </p>

        <div className="flex justify-center mb-5">
          <div className="p-4 bg-white rounded-2xl shadow-lg">
            <img src={qrUrl} alt="Contact QR code" className="w-56 h-56" data-testid="qr-code-image" />
          </div>
        </div>

        <button
          data-testid="qr-download-vcard-button"
          onClick={() => { downloadVCard(card); toast.success("vCard downloaded"); }}
          className="w-full flex items-center justify-center gap-2 py-3 rounded-xl border border-slate-700 text-slate-200 hover:border-blue-500 text-sm font-medium transition-colors"
        >
          <Download className="w-4 h-4" /> Or download .vcf
        </button>
      </div>
    </Modal>
  );
}
